/** @jsx jsx */
import { jsx } from '@emotion/core'
import React,{useEffect,useMemo,useState} from "react";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import ShoeListRow from '../components/ShoeListRow';
import CustomPagination from '../components/CustomPagination';
import ShoeListWithPictures2 from '../components/ShoeListWithPicturesV2';
import Button from 'react-bootstrap/Button';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../actions/Actions.js';
import Modal from "react-bootstrap/Modal";
import FilterContainer from "../components/FilterContainer.js";
import Form from "react-bootstrap/Form";
import {Helmet} from "react-helmet";
import Spinner from "react-bootstrap/Spinner";
import { useLocation } from "react-router-dom";
import isEqual from 'lodash/isEqual';
import Helper from "../functions/Helper.js";
import queryString from "query-string";
import { useAdthrive } from '../hooks/useAdThrive';

//import {Experiment,Variant} from "react-optimize";

/*
try{window.google_optimize={get:()=>"0"}}
catch(error){};
*/


const getJsonLD=(shoe_list)=>{
  return(
    {
      "@context":"http://schema.org",
      "@type": "ItemList",
      numberOfItems:shoe_list.length,
      itemListElement:shoe_list.map((shoe,index)=>({
        "@type": "ListItem",
        position:index+1,
        url:"https://www.thehoopsgeek.com/shoe-reviews/"+shoe.url+"/"
      }))
    }
  );
}

function getHelmet(props,pageIndex,pages,shoe_list,pageTitle="Basketball Shoe Reviews"){
  return(
    <Helmet>
      <meta property="og:image:width" content="1020" />
      <meta property="og:image:height" content="510" />
      <meta property="og:image" content= {"https://www.thehoopsgeek.com/wp-content/uploads/2018/07/10_best_basketball_shoes-2.png"}/>
      <meta property="og:title" content={pageTitle + " - " + props.stats.count + " Shoes starting from $" + props.stats.min_price.toFixed(2)}/>
      <meta property="og:description" content={"Check out basketball shoe reviews by true experts from Youtube and sneaker blogs. Find great deals from online sneaker stores."}/>
      <meta name="description" content={"Check out basketball shoe reviews by true experts from Youtube and sneaker blogs. Find great deals from online sneaker stores."}/>
      <title>{pageTitle + " - " + props.stats.count + " Shoes starting from $" + props.stats.min_price.toFixed(2)}</title>
      {pageIndex > 1 && <link rel='prev' href={"https://www.thehoopsgeek.com" + Helper.getNextUrl(Helper.nextFilterObject(props.filterObject,{"pg":getPaginationLink(Math.min(pages.length,pageIndex-1))}),props.urlMapping)}/>}
      {pageIndex < pages.length  && <link rel='next' href={"https://www.thehoopsgeek.com" +Helper.getNextUrl(Helper.nextFilterObject(props.filterObject,{"pg":getPaginationLink(Math.min(pages.length,pageIndex+1))}),props.urlMapping)}/>}
      <script type="application/ld+json">
        {JSON.stringify(getJsonLD(shoe_list))}
      </script>
    </Helmet>
  );
}

const getPaginationLink=(page)=>{
  if(page===1){
    return("")
  }
  else{
    return(page);
  }
}




function Overview (props){
  //useAdthrive(props.ssr);
  const [showResponsiveFilter,setShowResponsiveFilter]=useState(false);
  const {search,pathname } = useLocation();
  let currentMappedUrl=useMemo(()=>Helper.getMappingUrl(pathname,props.urlMapping),[pathname]);
  let sortBy=props.filterObject?.sortBy || "release_date";
  let sortOrder=props.filterObject?.order ||  (props.filterArray.filter((x)=>x.data===sortBy)[0].order ?? "desc");

  useEffect(() => {
    let filterObjectFromPath=Helper.getFilterObjectFromPath(pathname,search,props.urlMapping);
    if(filterObjectFromPath?.shoe_name ?? "" !== props.searchText){
      props.actions.searchtext(filterObjectFromPath?.shoe_name ?? "");
    }

    if(!isEqual(props.filterObject,filterObjectFromPath)){
      props.actions.start_filtering();
      props.actions.filterObject(filterObjectFromPath);
      let newpath=queryString.stringify(filterObjectFromPath)=="" ? "" : "?"+queryString.stringify(filterObjectFromPath);
      props.actions.fetchFilters(newpath);
      props.abortFunction();
    }
  }, [search,pathname]);


  const sortShoes=(category)=>{
    Helper.gaEvent("reviews", "sort",category);
    if(sortBy ===category){
      invertOrder();
    }
    else{
      let order=props.sortArray.filter((x)=>x.data===category)[0].order ?? "desc";
      let nextFilterObject=Helper.nextFilterObject(props.filterObject,{sortBy:category,order:order})
      let nextUrl=Helper.getNextUrl(nextFilterObject,props.urlMapping);
      props.history.push(nextUrl);
    }
  }

  const invertOrder=()=>{
    let newOrder=sortOrder ==="desc" ? "asc" :"desc";
    props.history.push(Helper.addQuestionMark(Helper.updateQueryString(search,"order",newOrder)));
  }

  let shoe_list = props.data;

  const pages = Helper.getPageArray(props.stats.count,props.shoesPerPage);
  let pageIndex=Number(props.filterObject?.pg || 1);
  let start_item=(pageIndex-1)*props.shoesPerPage;
  let end_item=pageIndex*props.shoesPerPage;

  if(start_item>shoe_list.length){
    start_item=0;
    end_item=props.shoesPerPage;
  }

  return (
    <div>
      {getHelmet(props,pageIndex,pages,shoe_list.slice(start_item,end_item),currentMappedUrl?.title ?? "Basketball Shoe Reviews")}


    {/*  <AdSense css={AdsenseStyle}  show={props.showAds} adSlot="3108102853"/> */}
        <Modal onHide={()=>{setShowResponsiveFilter(false)}} show={showResponsiveFilter}>
        <Modal.Header>
          <Modal.Title>Filter Shoes</Modal.Title>
        </Modal.Header>
        <button
          className="close"
          onClick={()=>{setShowResponsiveFilter(false)}}
          style={{padding:"0px 25px 20px 20px",fontSize:50,lineHeight:1,color:"#000",position:"absolute",zIndex:1000,right:0,top:0,}}
          type="button" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <Modal.Body>
          <FilterContainer  match={props.match} onHide={()=>{setShowResponsiveFilter(false)}}
            show={showResponsiveFilter}/>

        </Modal.Body>
        <div style={{borderTop:"1px solid #ccc",position:"fixed",display:"flex",width:"calc(min( 100% , 500px))",padding:20,bottom:0,paddingBottom:"calc(20px + env(safe-area-inset-bottom,0))",backgroundColor:"#f5f5f5"}}>
          <div style={{display:"flex",alignItems:"center",flex:1,fontSize:16}}>{props.stats.count} Available Shoes</div>
          <Button onClick={()=>{setShowResponsiveFilter(false)}}>Apply Filters</Button>
        </div>
      </Modal>

      {/*<div style={{marginTop:-20,marginBottom:20}} className="adthrive-leaderboard"/>*/}
      <div style={{display:"flex",marginBottom:80,marginTop:20}}>
        <div style={{minWidth:0}}>
          <div id="sticky_sidebar" className="d-none d-lg-block" style={{width:300,top:10,marginLeft:-10}}>
            <FilterContainer match={props.match} onHide={()=>{setShowResponsiveFilter(false)}}
              show={showResponsiveFilter}/>
          </div>
        </div>


        <div id="shoe_list" css={{"@media (min-width:992px)":{paddingLeft:50,paddingTop:10},flex:1,minWidth:0,position:"relative"}}>
          <div className={"mb-4"} style={{display:"flex"}}>
            <h1 className="thg_h5_size" style={{fontWeight:600,marginBottom:5}}>
              {currentMappedUrl?.title ?? "Basketball Shoe Reviews"}
            </h1>
            <div className={""} style={{display:"flex",flex:1,justifyContent:"flex-end",alignItems:"center"}}>
              <i title="Detailed View" onClick={()=>{props.actions.setFilterStyle(0)}} style={{fontSize:24,cursor:"pointer",marginRight:15,color:props.displayStyle===1 ? "#ced4da" :"#495057",}} className="fas fa-th-large"/>
              <i title="List View" onClick={()=>{props.actions.setFilterStyle(1)}} style={{fontSize:24,cursor:"pointer",color:props.displayStyle===0  ? "#ced4da" :"#495057",}} className="fas fa-list-ul"/>
            </div>
          </div>

          {props.filtering &&
            <Spinner animation="border" variant="primary" style={{position:"absolute",top:300,left:"50%"}}/>
          }
          <div  style={{opacity:props.filtering ? 0.5 :1 }}>

          <div className="d-md-flex " style={{fontSize:16,justifyContent:"flex-end",alignItems:"center",marginBottom:10}}>
            <div style={{display:"flex",flex:1}} className="my-2 my-md-0">
              <div css={{"@media (max-width: 767px)":{flex:1}}} style={{display:"flex",alignItems:"center"}}>
                {
                  props.switchValue ?
                  "You have " + props.stats.count + " favorite shoes" :
                  props.stats.count + " Shoes available"
                }
              </div>
              <div className="d-lg-none" style={{flex:0}}>

                <Button onClick={()=>{setShowResponsiveFilter(true)}} style={{color:"#333",height:"39.5px",marginLeft:10,paddingLeft:"20px",paddingRight:"20px",fontWeight:"600!important",borderColor:"#ced4da",backgroundColor:"white",whiteSpace:"nowrap",}} size={"sm"}>
                  <i className="fas fa-sliders-h"></i> Filter
                    {Helper.validFilterLength(props.filterArray,props.filterObject) > 0  &&
                      <div style={{display:"inline-block",marginLeft:5,marginRight:-5,width:20,height:20,borderRadius:10,backgroundColor:"var(--primary-color-600)",color:"#fff",textAlign:"center",fontWeight:600,fontSize:14,alignItems:"center",justifyContent:"center",lineHeight:"20px"}}>
                        {Helper.validFilterLength(props.filterArray,props.filterObject)}
                      </div>
                    }
                </Button>
              </div>
            </div>
            <div style={{alignItems:"center"}} className="d-flex my-2 my-md-0">
              <Form.Label style={{marginRight:10,flex:1,lineHeight:1.2}}>Sorted By:</Form.Label>
              <div style={{display:"flex"}} >
                <Form.Control
                  style={{fontSize:16}} value={sortBy || "release_date"}
                  onChange={(x)=>{sortShoes(x.target.value)}} as="select">
                  {props.sortArray.map((filter)=>
                    <option key={filter.data} value={filter.data}>{filter.text}</option>
                  )}
                </Form.Control>
                <div style={{display:"flex",alignItems:"center"}}>
                  {sortOrder==="desc"  &&
                    <i onClick={(x)=>{invertOrder()}} style={{cursor:"pointer",fontSize:24,color:"var(--primary-color-600)",marginLeft:10,}} className="fas fa-sort-alpha-down"/>
                  }
                  {sortOrder==="asc" &&
                    <i onClick={(x)=>{invertOrder()}} style={{cursor:"pointer",fontSize:24,color:"var(--primary-color-600)",marginLeft:10,}} className="fas fa-sort-alpha-up"/>
                  }
                </div>

              </div>

              <div className={"d-none"} style={{display:"flex",flex:1,justifyContent:"flex-end",alignItems:"center"}}>
                <i title="Detailed View" onClick={()=>{props.actions.setFilterStyle(0)}} style={{fontSize:24,cursor:"pointer",marginRight:15,color:props.displayStyle===1 ? "#ced4da" :"#495057",}} className="fas fa-th-large"/>
                <i title="List View" onClick={()=>{props.actions.setFilterStyle(1)}} style={{fontSize:24,cursor:"pointer",color:props.displayStyle===0  ? "#ced4da" :"#495057",}} className="fas fa-list-ul"/>
              </div>
            </div>
          </div>
          <div style={{borderBottom:"1px solid #eee",marginBottom:40}}/>
          <Row  style={{marginLeft:0,marginRight:0}}>
            <Col xs={12}>
              {props.displayStyle===1 &&
              <Row style={{marginBottom:10}} className="table_header_row">
                <Col className="table_header" style={{display: "flex"}} md={4}>
                  <div style={{width: 65}} onClick={() => {sortShoes("rating")}} className="table_header">
                    <i className="fa fa-sort"/>
                    Rating
                  </div>
                  <div style={{textAlign: "left",paddingLeft: 15}} onClick={() => {sortShoes("shoe_name")}} className="table_header">
                    <i className="fa fa-sort"/>
                    {" "}
                    Shoe
                  </div>
                </Col>
                <Col onClick={() => {sortShoes("release_date")}} className="table_header" md={1}>
                  <i className="fa fa-sort"/>
                  {" "}Release
                </Col>
                <Col onClick={() => {sortShoes("discount")}} className="table_header" md={1}>
                  <i className="fa fa-sort"/>
                  {" "}Price
                </Col>
                <Col onClick={() => {sortShoes("traction")}} className="table_header" md={1}>
                  <i className="fa fa-sort"/>
                  {" "}Traction
                </Col>
                <Col onClick={() => {sortShoes("cushion")}} className="table_header" md={1}>
                  <i className="fa fa-sort"></i>
                  {" "}Cushion
                </Col>
                <Col onClick={() => {sortShoes("materials")}} className="table_header" md={1}>
                  <i className="fa fa-sort"></i>
                  {" "}Materials
                </Col>
                <Col onClick={() => {sortShoes("support")}} className="table_header" md={1}>
                  <i className="fa fa-sort"></i>
                  {" "}Support
                </Col>
                <Col onClick={() => {sortShoes("fit")}} className="table_header" md={1}>
                  <i className="fa fa-sort"></i>
                  {" "}Fit
                </Col>
                <Col onClick={() => {sortShoes("outdoor")}} className="table_header" md={1}>
                  <i className="fa fa-sort"></i>
                  {" "}Outdoor
                </Col>
              </Row> }
            </Col>
            {
              shoe_list.map((shoe, index) => {
                let fav= props.favs.filter((x) => x === shoe.shoe_id).length !== 0 ? true:false;
                if(props.displayStyle===0){
                  return (
                    <React.Fragment key={shoe.shoe_id}>
                      <ShoeListWithPictures2 userRating={sortBy.includes("user")} index={index} sortBy={sortBy} fav={fav} addFav={props.actions.addFav} removeFav={props.actions.removeFav} expanded={props.expanded[shoe.shoe_id]} expand={props.actions.expand} shoe={shoe} />
                        {/* (index + 2) % 3 === 0 && index+1 !== shoe_list.length && 
                          <div className="adthrive-ad"/>
                  */}
                      </React.Fragment>
                );
                }
                else{
                  return (
                    <ShoeListRow userRating={sortBy.includes("user")} expanded={props.expanded[shoe.shoe_id]} expand={props.actions.expand} fav={fav} shoe={shoe} key={shoe.shoe_id}/>
                  );
                }
              }
              )
            }
            {
              shoe_list.length === 0 &&
                <div style={{width:"100%",textAlign: "center",paddingTop: 30,fontSize: 20}}>
                  {props.switchValue ===0 ? "No Shoes found" :
                    <div>
                      <div style={{fontSize:22,fontWeight:600,marginBottom:10}}>No favourites so far!</div>
                      Click the
                      <i title="Add to Favourites" className="far fa-star" style={{fontSize:26,lineHeight:"30px",marginLeft:5,marginRight:5,color:"#cccccc",cursor:"pointer"}}/>
                      to add a shoe to your favourites
                  </div>}
                </div>
            }
            <div style={{marginTop:20}}>
              <div style={{fontSize:14,marginBottom:10,fontWeight:600}}>
                Shoes {props.shoesPerPage * (pageIndex-1)+1} to {Math.min(props.stats.count,props.shoesPerPage * (pageIndex))} of {props.stats.count}
              </div>
              <CustomPagination
                getPaginationLink={(x)=>Helper.getNextUrl(Helper.nextFilterObject(props.filterObject,{"pg":getPaginationLink(x)}),props.urlMapping)}
                pages={pages}
                pageIndex={pageIndex}/>
            </div>
          </Row>
        </div>
      </div>
    </div>
  </div>
  );

}

export default connect(state => ({ ...state.data, ...state.persistData }), (dispatch) => ({
  actions: bindActionCreators(Actions, dispatch)
}))(Overview);
